import app1 from '../images/pricing_logo1.png';
import app2 from '../images/pricing_logo2.jpg';
import app3 from '../images/pricing_logo3.png';

export const appSectionData = {
  apps: [
    {
      img: app1,
      alt: 'Fydo',
      rating: 4.8,
    },
    {
      img: app2,
      alt: 'Fydo Partner',
      rating: 4.7,
    },
    {
      img: app3,
      alt: 'Greet',
      rating: 5,
    },
  ],
};
